const skillsList = [
    {
        name: "ReactJS",
        level: 96,
    },
    {
        name: "Javascript",
        level: 94,
    },
    {
        name: "HTML",
        level: 94,
    },
    {
        name: "CSS",
        level: 96,
    },
    {
        name: "Bootstrap",
        level: 96,
    },
    {
        name: "Redux",
        level: 80,
    },
    {
        name: "ES6",
        level: 86,
    },
    {
        name: "TypeScript",
        level: 70,
    },
    {
        name: "NodeJS",
        level: 75,
    },
    {
        name: "ExpressJS",
        level: 75,
    },
    {
        name: "MongoDB",
        level: 75,
    },
    {
        name: "NextJS",
        level: 60,
    },
    {
        name: "Angular",
        level: 60,
    },
    {
        name: "Firebase",
        level: 60,
    },
]

export default skillsList;